import { render, staticRenderFns } from "./CategoriaList.vue?vue&type=template&id=2b99549e&scoped=true&"
import script from "./CategoriaList.vue?vue&type=script&lang=js&"
export * from "./CategoriaList.vue?vue&type=script&lang=js&"
import style0 from "./CategoriaList.vue?vue&type=style&index=0&id=2b99549e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b99549e",
  null
  
)

export default component.exports